import React, { useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { Select, TextInput as MatTextInput } from 'react-materialize';
import emailjs from 'emailjs-com';
import TextInput from '../atoms/textinput.jsx';
import Button from '../atoms/button.jsx';
import { Label } from '../atoms/label.jsx';
import Row from '../organism/row.jsx';
import Banner from '../organism/banner.jsx';
import LoadingSpinner from '../organism/spinner.jsx';
import { COLOR, SIZE, KEY, LABEL, FONT_FAMILY, SCREEN_MEDIA } from '../../utils/constants.js';
import { useDecorationTypes } from '../hooks/useDecorationTypes.js';
import { getDecorationTypeLv1List } from '../../utils/managerdecorations.js';

const Container = styled.div`
    overflow: auto; // To cover height with contents
    padding: 0px 15px;
    @media only screen and ${SCREEN_MEDIA.small} {
        margin: 0px 2px;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        margin: 30px 80px;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        margin: 30px 150px;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        margin: 30px 250px;
    }
`;

const FormCard = styled.div`
    overflow: auto; // To cover height with contents
    padding: 25px;
    background-color: ${COLOR.background};
    border-radius: 25px;
    -webkit-box-shadow: -1px 0px 22px -3px rgba(153,153,153,1);
    -moz-box-shadow: -1px 0px 22px -3px rgba(153,153,153,1);
    box-shadow: -1px 0px 22px -3px rgba(153,153,153,1);
`;

const StepContent = styled.div`
    display: ${props => props.active ? 'block' : 'none'};
`;

const BodyEventBooking = () => {

    const { data: decorationTypeList, isLoading } = useDecorationTypes();

    const decorationTypesLv1 = useMemo(() => {
        return decorationTypeList ? getDecorationTypeLv1List(decorationTypeList) : [];
    }, [decorationTypeList]);

    const form = useRef();
    const [step, setStep] = useState(1);
    const [isSending, setIsSending] = useState(false);
    const [selectedTypeId, setSelectedTypeId] = useState('');

    const goToStep2 = (e) => {
        e.preventDefault();
        setStep(2);
    };

    const goToStep1 = (e) => {
        e.preventDefault();
        setStep(1);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSending(true);
        emailjs.sendForm(KEY.emailJsService, KEY.emailJsTemplate, form.current, KEY.emailJsUserId)
            .then(() => {
                setIsSending(false);
                window.M.toast({
                    html: '¡Solicitud de reserva enviada!',
                    classes: 'rounded green',
                    displayLength: 3000
                });
                form.current.reset();
                setStep(1);
            }, (error) => {
                console.log(error.text);
                setIsSending(false);
                window.M.toast({
                    html: 'Ocurrió un error al enviar tu reserva',
                    classes: 'red',
                    displayLength: 3000
                });
            });
    };

    if (isLoading) return <LoadingSpinner/>;

    if (isSending) return <LoadingSpinner/>;

    return (
        <div>
            <Banner title='Reserva tu evento'/>

            <Container>
                <Row margin='40px 0px'>
                    <FormCard>
                        <Label
                            margin='0 0 30px 0'
                            text_size={SIZE.title}
                            text_color={COLOR.ferra}
                            font_family={FONT_FAMILY.avenirMedium}>
                            { step === 1
                                ? 'Paso 1 de 2: Cuéntanos sobre tu evento'
                                : 'Paso 2 de 2: Confirma tu pago' }
                        </Label>

                        <form ref={form} onSubmit={handleSubmit}>

                            <StepContent active={step === 1}>
                                <Select
                                    id='eventType'
                                    name='eventType'
                                    multiple={false}
                                    noLayout
                                    onChange={ (event) => setSelectedTypeId(event.target.value) }
                                    options={{
                                        dropdownOptions: {
                                            closeOnClick: true
                                        }
                                    }}>
                                    <option value='' disabled selected>Tipo de evento</option>
                                    {
                                        decorationTypesLv1.map((item, index) => {
                                            return <option value={item.id}>{item.title}</option>
                                        })
                                    }
                                </Select>
                                <TextInput
                                    id='organizerName'
                                    name='organizerName'
                                    type='text'
                                    label='Nombre del organizador*'
                                    placeholder='Alexandra Pinedo'
                                    margin='46px 0'
                                    onChange={ () => {} }/>
                                {
                                    (Number(selectedTypeId) === 100001 ||
                                    Number(selectedTypeId) === 100002 ||
                                    Number(selectedTypeId) === 100007) &&
                                    <TextInput
                                        id='celebrantName'
                                        name='celebrantName'
                                        type='text'
                                        label='Nombre del festejado*'
                                        placeholder='Juan Soto'
                                        margin='35px 0'
                                        onChange={ () => {} }/>
                                }
                                {
                                    Number(selectedTypeId) === 100001 &&
                                    <TextInput
                                        id='birthNumber'
                                        name='birthNumber'
                                        type='number'
                                        label='Número de cumpleaño*'
                                        placeholder='7'
                                        margin='35px 0'
                                        onChange={ () => {} }/>
                                }
                                {
                                    (Number(selectedTypeId) === 100004 || Number(selectedTypeId) === 100005) &&
                                    <div>
                                        <TextInput
                                            id='couplePerson1Name'
                                            name='couplePerson1Name'
                                            type='text'
                                            label='Pareja. Persona 1. Nombre*'
                                            placeholder='José Pitrola'
                                            margin='35px 0'
                                            onChange={ () => {} }/>
                                        <TextInput
                                            id='couplePerson2Name'
                                            name='couplePerson2Name'
                                            type='number'
                                            label='Pareja. Persona 2. Nombre*'
                                            placeholder='Rosa Melculo'
                                            margin='35px 0'
                                            onChange={ () => {} }/>
                                    </div>
                                }
                                {
                                    Number(selectedTypeId) === 100008 &&
                                    <TextInput
                                            id='corporateName'
                                            name='corporateName'
                                            type='text'
                                            label='Nombre de empresa/negocio*'
                                            placeholder='Villacount'
                                            margin='35px 0'
                                            onChange={ () => {} }/>
                                }
                                <TextInput
                                    id='thematicName'
                                    name='thematicName'
                                    type='text'
                                    label='Temática (Opcional)'
                                    placeholder='Mariposas'
                                    margin='35px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='eventDate'
                                    name='eventDate'
                                    type='date'
                                    label='Fecha del evento*'
                                    margin='35px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='eventTime'
                                    name='eventTime'
                                    type='time'
                                    label='Hora del evento*'
                                    margin='35px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='houseName'
                                    name='houseName'
                                    type='text'
                                    label='Nombre del local/recinto (Opcional)'
                                    placeholder='Lumaja'
                                    margin='35px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='address'
                                    name='address'
                                    type='text'
                                    label='Dirección completa*'
                                    placeholder='Av. Pacífico 350'
                                    margin='35px 0'
                                    onChange={ () => {} }/>
                                <TextInput
                                    id='phone'
                                    name='phone'
                                    type='tel'
                                    label='Teléfono de contacto / WhatsApp*'
                                    placeholder='944555666'
                                    margin='35px 0'
                                    onChange={ () => {} }/>

                                <Button
                                    type='button'
                                    width='140px'
                                    height='46px'
                                    bg_color={ COLOR.primary }
                                    margin='10px 0 0 0'
                                    float='right'
                                    onClick={ goToStep2 }>
                                    <Label
                                        text_color={ COLOR.ferra }
                                        text_size={SIZE.subtitle}
                                        font_family={FONT_FAMILY.avenirMedium}
                                        margin='auto'>
                                        Siguiente
                                    </Label>
                                </Button>
                            </StepContent>

                            <StepContent active={step === 2}>
                                <Label
                                    margin='0 0 20px 0'
                                    text_size={SIZE.subtitle}
                                    text_color={COLOR.black}
                                    font_family={FONT_FAMILY.avenirMedium}>
                                    Adjunta la captura de pago
                                </Label>
                                <MatTextInput
                                    id='paymentScreenshot'
                                    name='paymentScreenshot'
                                    type='file'
                                    accept='image/png, image/jpeg'
                                    noLayout
                                    onChange={ () => {} }/>

                                <Button
                                    type='button'
                                    width='120px'
                                    height='46px'
                                    border_color={ COLOR.grayDark }
                                    text_color={ COLOR.grayDark }
                                    margin='30px 10px 0 0'
                                    float='left'
                                    onClick={ goToStep1 }>
                                    <Label
                                        text_color={ COLOR.grayDark }
                                        text_size={SIZE.subtitle}
                                        font_family={FONT_FAMILY.avenirMedium}
                                        margin='auto'>
                                        Atrás
                                    </Label>
                                </Button>
                                <Button
                                    type='submit'
                                    width='120px'
                                    height='46px'
                                    bg_color={ COLOR.primary }
                                    margin='30px 0 0 0'
                                    float='right'
                                    onChange={ () => {} }>
                                    <Label
                                        text_color={ COLOR.ferra }
                                        text_size={SIZE.subtitle}
                                        font_family={FONT_FAMILY.avenirMedium}
                                        margin='auto'>
                                        {LABEL.send}
                                    </Label>
                                </Button>
                            </StepContent>

                        </form>
                    </FormCard>
                </Row>
            </Container>
        </div>
    );
};

export default BodyEventBooking;
